import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastNotificationService } from '../../../shared/toast-notification.service';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../auth/service/auth.service';

@Injectable({
  providedIn: 'root'
})

export class PostCustomerService {

  apiUrl = environment.apiUrl;
  testUrl = 'https://test.api.tridimo.de/api/'
  ProductionUrl = 'https://api.tridimo.de/api/'
  devApi = 'https://dev.api.tridimo.de/api/';
  token = "";
  storedData = localStorage.getItem("authUser"); 

  constructor(private http: HttpClient, private toastService: ToastNotificationService, public authService: AuthService) { }

  async postCustomer(newCustomerData: any): Promise<any> {
    const customerData = {
      email: newCustomerData.email,
      firstName: newCustomerData.firstname,
      lastName: newCustomerData.lastname,
      hearingstate: newCustomerData.hearingstate,
      gender: newCustomerData.gender,
      birthdate: newCustomerData.birthdate,
      adress: newCustomerData.adress,
      city: newCustomerData.city,
      postalcode: newCustomerData.postalcode,
      information: newCustomerData.information,
      phonenumber: newCustomerData.phonenumber,
      phonenumber2: newCustomerData.phonenumber2,
      mobilumber: newCustomerData.mobilumber,
      HS_reference_ID: null,
      stammteam: newCustomerData.stammteam,
      stammkunde: newCustomerData.stammkunde,
      stammkundeDolmetscher: newCustomerData.stammkundenDolmetscher,
      unternehmen: newCustomerData.unternehmen,
      color: newCustomerData.color
    };

    console.log('NEW CUSTOMER DATA--> ', customerData);

    try {
      const options = this.setFetchOptions();
      const response = await this.http.post(`${this.apiUrl}customer/`, customerData, options).toPromise();
      console.log("Customer Post successfully:", response);
      this.toastService.successToast(`Kunde angelegt`);
      return response;
    } catch (error) {
      console.error("Error Post Customer:", error);
      this.toastService.dangerToast(`Fehler beim Anlegen des Kunden`);
      return await Promise.reject(error);
    }
  }


  setFetchOptions() {
    let options: any = {};
    
    if (this.apiUrl === this.devApi ) {
      let token = "";
      let exp = '';
      this.getStoredData();
      if (this.storedData) {
        try {
          const parsedData = JSON.parse(this.storedData);
          token = parsedData.token;
          exp = parsedData.exp;
          this.checkToken(exp);
        } catch (error) {
          console.error("Fehler beim Parsen des Tokens:", error);
          this.logout();
        }
      } else {
        this.logout();
        // console.log("Kein Token im Local Storage gefunden.");
      }
  
      const headers = new HttpHeaders({
        'Authorization': `${token}`,
        'Content-Type': 'application/json'
      });
      
      options.headers = headers;
    } else {
        options.withCredentials = true;
    }
    
    return options;
  }


  checkToken(token: any) {
    try {
      const expirationTime = token * 1000;
      const currentTime = Date.now();
      if (currentTime > expirationTime) {
        // console.log('Token ist älter als 60 Minuten');
        this.logout()
      } else {
        // console.log('Token ist noch gültig');
      }
    } catch (e) {
      console.error('Fehler beim Dekodieren des Tokens:', e);
      this.logout()
    }
  }


  logout() {
    //localStorage.clear();
    sessionStorage.clear();
    this.authService.logout();
  }


  async getStoredData() {
    this.storedData = localStorage.getItem("authUser"); 
  }
}
